var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_2",
    "data-name": "Laag 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 156.06 155.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #68be6a;\n        stroke: #68be6a;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #68aabe;\n        stroke: #68aabe;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #fc850f;\n      }\n\n      .cls-4 {\n        fill: #fff;\n        stroke: #fff;\n        stroke-width: 1.15px;\n      }\n\n      .cls-5 {\n        fill: #fc850f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_1-2",
    "data-name": "Laag 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.29,98.71C-14.2,36.55,39.08.01,76.17.5c.25,19.2.25,25.84,0,75.77L10.83,113.72"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.17,
    y1: 0.01,
    x2: 76.17,
    y2: 76.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.4,
    y1: 113.97,
    x2: 76.42,
    y2: 75.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.83,113.72C-15.49,67.37,10.83,4.05,76.17.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M152.01,98.71C170.49,36.55,117.22.01,80.12.5c-.25,19.2-.25,25.84,0,75.77l65.34,37.45"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 80.12,
    y1: 0.01,
    x2: 80.12,
    y2: 76.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 145.89,
    y1: 113.97,
    x2: 79.87,
    y2: 75.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M145.46,113.72c26.32-46.35,0-109.67-65.34-113.21"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.84,129.26c-44.38,47.29-102.79,19.67-121.05-12.62,16.45-9.89,22.19-13.24,65.45-38.17l65.26,37.57"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12.36,
    y1: 116.89,
    x2: 78.24,
    y2: 78.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 143.93,
    y1: 116.29,
    x2: 77.74,
    y2: 78.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.5,116.04c-26.78,46.09-94.73,55.25-130.71.6"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 78.14,
    cy: 76.88,
    r: 35.89
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9ab71b6ccd4877650ab58ccff8f35ddb.svg";
export { ForwardRef as ReactComponent };